import {
  IRecordGroupExpenseDetail,
  IRecordGroupExpenseRequest,
} from '@/dataSource/src/api/groups/entities';
import {
  ISplitBill,
  ISplitBillGroup,
} from '@/dataSource/src/api/split-bills/entities';
import {
  ICreateSplitBillsLinkDetail,
  ICreateSplitBillsLinkRequest,
  ISplitOwner,
} from '@/dataSource/src/api/splits/entities';

export function buildCreateSplitPayload(params: {
  session_id: string;
  splitBill: ISplitBill;
  owner: ISplitOwner;
  payment_link: string;
  public_url?: string;
  referral_code?: string;
}): ICreateSplitBillsLinkRequest {
  const {
    session_id,
    splitBill,
    owner,
    payment_link,
    public_url,
    referral_code,
  } = params;

  const detail: ICreateSplitBillsLinkDetail = {
    description: splitBill?.description ?? '',
    items: (splitBill?.items ?? []).map(item => ({
      description: item.description,
      shared_by: item.shared_by ?? [],
      subtotal: item.subtotal,
      tax: item.tax,
      tip: item.tip,
      total: item.total,
    })),
    participants: splitBill?.participants ?? [],
    split: splitBill?.split ?? {},
    subtotal: splitBill?.subtotal ?? 0,
    taxes: splitBill?.taxes ?? 0,
    tip: splitBill?.tip ?? 0,
    total: splitBill?.total ?? 0,
  };

  const body: ICreateSplitBillsLinkRequest = {
    session_id,
    payment_link,
    ...(public_url && {public_url}),
    owner,
    detail,
    ...(referral_code && {metadata: {referral_code}}),
  };

  return body;
}

export function buildCreateSplitPayloadV2(params: {
  created_by: string;
  splitBillGroup: ISplitBillGroup;
}): IRecordGroupExpenseRequest {
  const {created_by, splitBillGroup} = params;

  const detail: IRecordGroupExpenseDetail = {
    items: (splitBillGroup?.detail?.items ?? []).map(item => ({
      description: item.description,
      shared_by_ids: item.shared_by_ids ?? [],
      subtotal: item.subtotal,
      tax: item.tax,
      tip: item.tip,
      total: item.total,
    })),
    subtotal: splitBillGroup?.detail?.subtotal ?? 0,
    taxes: splitBillGroup?.detail?.taxes ?? 0,
    tip: splitBillGroup?.detail?.tip ?? 0,
    total: splitBillGroup?.detail?.total ?? 0,
  };

  return {
    created_by: created_by,
    session_id: splitBillGroup?.session_id ?? '',
    description: splitBillGroup?.description ?? '',
    payers: (splitBillGroup?.payers ?? []).map(p => ({
      split_user_id: p.split_user_id,
      amount: p.amount,
    })),
    participants: (splitBillGroup?.participants ?? []).map(p => ({
      split_user_id: p.split_user_id,
      amount: p.amount,
    })),
    detail,
  };
}
